import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Column } from "@sm/helpers/simple-flexbox";
import { Panel } from "react-bootstrap";

import CustomButton from "@sm/components/custom/Button";
import PageHeader from "@sm/components/PageHeader";
import Form from "@sm/core/Form";
import Spinner from '@sm/components/Spinner';

import '@assets/css/myAccount.css';
import MyAccountIcon from '@assets/images/myaccount.png';
import localization from '@assets/lang/language';

import * as actions from "@sm/actions";
import { crudActions } from "@sm/services/crudActions";
import { PASSWORD_REGEX } from "@sm/constants";

class MyAccount extends Component {
  state = {
    accountForm: new Form({
      name: "",
      phone: "",
      skype: "",
      currentPassword: null,
      newPassword: null
    }, [{
      name: "name",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "phone",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "skype",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "currentPassword",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "newPassword",
      type: "isPattern",
      rules: {
        required: false,
        pattern: PASSWORD_REGEX,
        customErrorMessage: "Password must contain at least 1 lowercase alphabetical character, 1 uppercase alphabetical character, 1 numeric character, 1 special character and must be 8 characters or longer"
      }
    }]),

    username: "",
    role: "",
    whiteLabels: "",
    merchants: "",

    confirmPassword: "",
    confirmPasswordTouched: false,
    isLoading: true,
    isSubmitting: false,

    //temporary
    currentLanguage: "en"
  };

  componentDidMount() {
    const { accountForm } = this.state;

    crudActions.get(`v1/myaccount`).then(
      (accountData) => {
        if (accountData) {
          this.setState({
            accountForm: Object.assign(accountForm, {
              name: accountData.name,
              phone: accountData.phone,
              skype: accountData.skype
            }),
            username: accountData.username,
            role: accountData.role,
            whiteLabels: accountData.whiteLabels.join(", "),
            merchants: accountData.merchants.join(", "),
            isLoading: false
          });
        }
      }
    ).catch(
      (err) => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      }
    );
  };

  onValueChange = (event, fieldName) => {
    const { accountForm } = this.state;
    this.setState({
      accountForm: Object.assign(accountForm, {
        [fieldName]: event.target.value
      })
    });
  };

  onConfirmPasswordChange = (event) => {
    this.setState({
      confirmPassword: event.target.value,
      confirmPasswordTouched: true
    });
  };

  arePasswordsIdentical = () => {
    const { accountForm, confirmPassword } = this.state;

    if (!accountForm.currentPassword && !accountForm.newPassword) {
      return true;
    }

    return accountForm.newPassword === confirmPassword;
  };

  submitAccountSettings = () => {
    const { accountForm } = this.state;
    const isFormValid = accountForm.isFormValid();
    this.setState({
      accountForm: accountForm,
      confirmPasswordTouched: true
    });

    if (isFormValid && this.arePasswordsIdentical()) {
      this.setState({
        isSubmitting: true
      });
      const data = Object.assign(accountForm.data(), {
        fullName: accountForm.name
      });
      crudActions.put(`v1/myaccount`, data).then(
        () => {
          this.props.showAlert(true, "success", "Your data was successfully updated.");
          this.setState({
            isSubmitting: false
          });
        }
      ).catch(
        (err) => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
            this.setState({
              isSubmitting: false
            });
          }
        }
      );
    }
  };

  render() {
    const { accountForm, confirmPassword, confirmPasswordTouched, username, isLoading,
      currentLanguage, role, whiteLabels, merchants, isSubmitting } = this.state;
    const language = localization[currentLanguage];

    return (
      <Row flexGrow={ 1 } className="module apidata my-account" vertical='start'>
        <Column flexGrow={ 1 }>
          <PageHeader
            title="My Account"
            img={ MyAccountIcon }
          />
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    USER INFO
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <form autoComplete="off">
                    <input type="password" autoComplete="new-password" style={ { display: "none" } }/>
                    { isLoading ? (
                      <div style={ { width: "100%", height: "200px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                        <Spinner smallContainer={ true } />
                      </div>) : (
                      <div className="panel-content" style={ {overflow: 'unset'} }>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Full Name </label>
                            <input
                              className={ "form-control " + (accountForm.errors.has('name') ? 'error-field' : '') }
                              value={ accountForm.name || '' }
                              onChange={ (e) => this.onValueChange(e, "name") }/>
                            { accountForm.errors.has('name') && <p className="error-message"> { accountForm.errors.get('name') } </p> }
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Phone </label>
                            <input
                              className={ "form-control " + (accountForm.errors.has('phone') ? 'error-field' : '') }
                              value={ accountForm.phone || '' }
                              onChange={ (e) => this.onValueChange(e, "phone") }/>
                            { accountForm.errors.has('phone') && <p className="error-message"> { accountForm.errors.get('phone') } </p> }
                          </Column>
                      
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Skype </label>
                            <input
                              className={ "form-control " + (accountForm.errors.has('skype') ? 'error-field' : '') }
                              value={ accountForm.skype || '' }
                              onChange={ (e) => this.onValueChange(e, "skype") }/>
                            { accountForm.errors.has('skype') && <p className="error-message"> { accountForm.errors.get('skype') } </p> }
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Email/username </label>
                            <input
                              className="form-control"
                              disabled
                              value={ username || '' }/>
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <h5 className="change-password-title"> CHANGE PASSWORD </h5>
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Current Password </label>
                            <input
                              type="password"
                              className={ "form-control " + (accountForm.errors.has('currentPassword') ? 'error-field' : '') }
                              value={ accountForm.currentPassword || '' }
                              onChange={ (e) => this.onValueChange(e, "currentPassword") }/>
                            { accountForm.errors.has('currentPassword') && <p className="error-message"> { accountForm.errors.get('currentPassword') } </p> }
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> New Password </label>
                            <input
                              type="password"
                              className={ "form-control " + (accountForm.errors.has('newPassword') ? 'error-field' : '') }
                              value={ accountForm.newPassword || '' }
                              onChange={ (e) => this.onValueChange(e, "newPassword") }/>
                            { accountForm.errors.has('newPassword') && <p className="error-message"> { accountForm.errors.get('newPassword') } </p> }
                          </Column>
                          <Column flexGrow={ 1 } vertical='end' alignSelf='start' className="input-column">
                            <label> New Password Again </label>
                            <input
                              type="password"
                              className={ "form-control " + (!this.arePasswordsIdentical() && confirmPasswordTouched ? 'error-field' : '') }
                              value={ confirmPassword || '' }
                              onChange={ (e) => this.onConfirmPasswordChange(e) }/>
                            { !this.arePasswordsIdentical() && confirmPasswordTouched && <p className="error-message">
                              { !confirmPassword ? "Please, confirm the password."  : "Passwords are not identical." } </p>}
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <span/>
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <h5 className="change-password-title"> ACCESS </h5>
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> User Level </label>
                            <input
                              className="form-control"
                              disabled
                              value={ language.roles[role] || '' }/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> White Label </label>
                            <input
                              className="form-control"
                              disabled
                              value={ whiteLabels || '' }/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Merchant </label>
                            <input
                              className="form-control"
                              disabled
                              value={ merchants || '' }/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='end' alignSelf='end' className="input-column">
                            <CustomButton
                              title="Save"
                              type="button"
                              disabled={ isSubmitting }
                              onClick={ this.submitAccountSettings }
                            />
                          </Column>
                        </Row>
                      </div>
                    )}
                  </form>
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
    );
  }
};

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(MyAccount);
